module.exports = __webpack_public_path__ + "img/plus.4bc9b38c.svg";